<template>
    <header class="ms-header">
        <div class="ms-container" v-if="ll">
            <div class="ms-header__wrap">
                <div class="ms-header__logo">
                    <a href="/"><img src="/img/logo.svg" alt=""></a>
                </div>
                <div class="burger-menu" @click="menuOpen = !menuOpen">
                    <span></span>
                </div>
                <div class="ms-header__btn-mobi">
                    <a :href="$root.downloadLink" :download="$root.downloadName" class="btn btn-green ">
                        <span data-vl="10149" v-html="ll.i10149||'Download <strong>MyPrintScreen</strong> for free'"> </span>
                        <img src="/img/arrow-download.svg" alt="">
                    </a>
                </div>
                <div class="ms-header__menu" :class="[menuOpen?'active':'']">
                    <nav class="ms-header__nav ">
                        <ul class="nav-list">
                            <li class="nav-list__item ">
                                <router-link :to="'/'" replace data-vl="10146">{{ll.i10146||'Home'}}</router-link>
                            </li>
                            <li class="nav-list__item">
                                <router-link :to="'/#faq'" replace data-vl="10147">{{ll.i10147||'FAQ'}}</router-link>
                            </li>
                            <li class="nav-list__item">
                                <router-link :to="'/#contact'" replace data-vl="10148">{{ll.i10148||'Contact us'}}</router-link>
                            </li>
                        </ul>
                    </nav>
                    <div class="ms-header__btn">
                        <a :href="$root.downloadLink" :download="$root.downloadName" class="btn btn-green ">
                            <span data-vl="10149" v-html="ll.i10149||'Download <strong>MyPrintScreen</strong> for free'"> </span>
                            <img src="/img/arrow-download.svg" alt="">
                        </a>
                    </div>
                    <div class="ms-header__language" :class="[showLang?'active':'']" v-click-outside="outsideFunc">
                        <div class="language-img" :class="[showLang?'active':'']" @click="showLang=!showLang">
                            <img :src="'/img/flags/iso/flat/24/'+hflag.flag+'.png'" :alt="$root.lang" />
                            <p>{{hflag.lang_name}}</p>
                            <img class="arrow-lang" src="/img/arrow-lang.svg" :alt="$root.lang">
                        </div>
                        <div class="language-wrap" :class="[showLang?'active':'']">
                            <h4 data-vh="10150"><span @click="showLang=!showLang" class="backMenu"><img class="arrow-lang-mobi" src="/img/arrow-lang.svg" :alt="$root.lang" />{{ll.i10150||'Menu'}}</span></h4>

                            <ul class="language-list language-full">
                                <li v-for="(row, index) in $root.langObj" :key="index" :data-value="row.lang"
                                    @click="selectLang(row.lang)" class="language-list__item">
                                    <img :src="'/img/flags/iso/flat/24/'+row.flag+'.png'" :alt="row.lang" />
                                    <span>{{row.lang_name}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "AppHeader",
        computed:{
            ll(){
                return this.$root.ll;
            },
            hflag(){
                let index = this.$root.langObj.findIndex(row2 => row2.lang == this.$root.lang);
                return this.$root.langObj[index];
            }
        },
        data: function() {
            return{
                showLang: false,
                menuOpen: false
            }
        },
        methods: {
            async init(){

            },
            outsideFunc(){
                this.showLang = false;
            },
            async selectLang(lang){
                let res = await axios.post('/api/main/selectLang', {lang:lang});
                if(res && res.data && res.data.result){
                    this.$root.lang = lang;
                    await this.$root.getll(false);
                    this.showLang = false;
                    //this.setLocation(this.$root.lang);
                    let domain = window.mdomain || 'myprintscreen.com';
                    if(this.$root.lang=='en') window.location.href = window.location.protocol+'//'+domain+window.location.pathname;
                    else window.location.href = window.location.protocol+'//'+this.$root.lang+'.'+domain+window.location.pathname;
                }
            },
            setLocation(curLoc){
                try {
                    history.pushState(null, null, curLoc);
                    return;
                } catch(ee) {console.log(ee)}
                location.hash = '#' + curLoc;
            }
        },
        mounted(){
            this.init();
        }
    }
</script>

<style scoped>

</style>